// extracted by mini-css-extract-plugin
export default {"appContainer":"app_appContainer__75Hvr","appErrorContainer":"app_appErrorContainer__yUCj9"};